import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
  Bar,
  BarChart,
  Line,
  LineChart,
  Tooltip,
  XAxis,
  YAxis,
  ResponsiveContainer,
} from "recharts";

import Header from "../../components/Header/Header";
import {
  getDashboardStats,
  getGamePerformance,
  getRevenueData,
  getTopSelling,
  getUserActivity,
} from "../../api/dashboardApi";

import "./Dashboard.css";
import useDashboardStats from "../../hooks/useDashboardStats";
import useTopSelling from "../../hooks/useTopSelling";
import useDashboardGraph from "../../hooks/useDashboardGraph";

const months = [
  { label: "Jan", value: 1 },
  { label: "Feb", value: 2 },
  { label: "Mar", value: 3 },
  { label: "Apr", value: 4 },
  { label: "May", value: 5 },
  { label: "Jun", value: 6 },
  { label: "Jul", value: 7 },
  { label: "Aug", value: 8 },
  { label: "Sep", value: 9 },
  { label: "Oct", value: 10 },
  { label: "Nov", value: 11 },
  { label: "Dec", value: 12 },
];

const years = [2023, 2024, 2025, 2026, 2027, 2028];

export default function Dashboard() {
  const [lineData, setLineData] = useState([]);
  const [barData, setBarData] = useState([]);
  const [selling, setSelling] = useState([]);
  const [activity, setActivity] = useState([]);

  const [activeUsers, setActiveUsers] = useState("00,000");
  const [players, setPlayers] = useState({});
  const [totalRevinue, setTotalRevinue] = useState("00,000");

  const [selectedMonth, setSelectedMonth] = useState(10);
  const [selectedYear, setSelectedYear] = useState(2025);

  const { getStatsData, loading, statsData } = useDashboardStats();
  const { getTopSelling, topSellingData } = useTopSelling();
  const { fetchRevenueGraph } = useDashboardGraph();

  // useEffect(() => {
  //   const fetchDasboardData = async () => {
  //     const stats = await getStatsData();

  //     console.log("statsssss:", stats);
  //     setActiveUsers(stats?.data?.activeUsers ?? "00,000");
  //     setPlayers(stats?.data?.gamePlayed ?? "00,000");
  //   };
  //   fetchDasboardData();
  // }, []);

  const fetchDasboardData = async () => {
    const [stats, topSelling] = await Promise.all([
      getStatsData(),
      getTopSelling(),
    ]);
    setActiveUsers(stats?.data?.activeUsers ?? "00,000");
    setPlayers(stats?.data?.gamePlayed ?? "00,000");
    setTotalRevinue(stats?.data?.totalRevenue || []);
    setSelling(topSelling?.data || []);
    console.log(
      "top selling:",
      topSelling,
      stats?.data?.totalRevenue?.[0].totalRevenue,
    );
  };

  useEffect(() => {
    fetchDasboardData();
  }, []);

  const fetchRevenue = async () => {
    const res = await getRevenueData(selectedMonth, selectedYear);
    setBarData(res?.data || []);
  };

  useEffect(() => {
    fetchRevenue();
  }, [selectedMonth, selectedYear]);

  // useEffect(() => {
  //   const fetchDashboard = async () => {
  //     try {
  //       const stats = await getDashboardStats();
  //       const performance = await getGamePerformance();
  //       const revenue = await getRevenueData();
  //       const topSelling = await getTopSelling();
  //       const userActivity = await getUserActivity();

  //       // setActiveUsers(stats?.activeUsers ?? "00,000");
  //       // setPlayers(stats?.players ?? "00,000");

  //       setLineData(performance ?? []);
  //       setBarData(revenue ?? []);
  //       // setSelling(topSelling ?? []);
  //       setActivity(userActivity ?? []);
  //     } catch (error) {
  //       console.error("Dashboard API Error:", error);
  //     }
  //   };

  //   fetchDashboard();
  // }, []);

  return (
    <div className="dashboard-container">
      <Header />

      {/* STATUS */}

      <Row className="margin-none">
        <div className="status">
          <div className="status-card">
            <p className="status-title">Active Users</p>

            <h2 className="status-value">{activeUsers}</h2>

            <span className="status-subtitle">from last month</span>
          </div>

          <div className="status-card">
            <p className="status-title">Total Games Played</p>

            <div className="game-row">
              <span>Timely Game</span>
              <strong>{players?.timelyGamePlayed ?? 0}</strong>
            </div>

            <div className="game-row">
              <span>Infinite Game</span>
              <strong>{players?.infiniteGamePlayed ?? 0}</strong>
            </div>
          </div>
          <div className="status-card">
            <p className="status-title">Total Revenue</p>

            <h2 className="status-value">
              {" "}
              ₹{totalRevinue?.[0]?.totalRevenue ?? 0}
            </h2>
          </div>
        </div>
      </Row>

      {/* CHARTS */}
      <Row className="margin-none">
        <Col md={8}>
          <div className="linechart">
            <h5>Game Performance</h5>
            <span>comparison between infinite and time games</span>

            <ResponsiveContainer width="100%" height={250}>
              <LineChart data={lineData}>
                <XAxis dataKey="Key" />
                <YAxis />
                <Tooltip />
                {/* <Line dataKey="value1" stroke="#8a9f7bff" />
                <Line dataKey="value2" stroke="#8a9f7bff" /> */}
                <Line dataKey="value1" stroke="#00E6FF" strokeWidth={3} />

                <Line dataKey="value2" stroke="#FF007D" strokeWidth={3} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </Col>

        <Col md={4}>
          <div className="barchart">
            {/* <h5>Revenue Growth</h5>
              <span>monthly revenue for past 6 months</span> */}
            <div className="chart-filters">
              <div className="chart-heading">
                <h5>Revenue Growth</h5>
                <span>monthly revenue for past 6 months</span>
              </div>

              <div className="chart-filter-actions">
                <select
                  value={selectedMonth}
                  onChange={(e) => setSelectedMonth(Number(e.target.value))}
                >
                  {months.map((month) => (
                    <option key={month.value} value={month.value}>
                      {month.label}
                    </option>
                  ))}
                </select>

                <select
                  value={selectedYear}
                  onChange={(e) => setSelectedYear(Number(e.target.value))}
                >
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <ResponsiveContainer width="100%" height={250}>
              <BarChart data={barData}>
                <defs>
                  <linearGradient
                    id="revenueGradient"
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="1"
                  >
                    <stop offset="0%" stopColor="#00E6FF" />
                    <stop offset="100%" stopColor="#FF007D" />
                  </linearGradient>
                </defs>
                <XAxis dataKey="month" />
                <YAxis />
                {/* <Tooltip /> */}
                <Tooltip
                  formatter={(value) => [`₹${value}`, "Revenue"]}
                  contentStyle={{
                    backgroundColor: "#111827",
                    border: "1px solid #374151",
                    borderRadius: "10px",
                    color: "#ffffff",
                  }}
                  labelStyle={{
                    color: "#ffffff",
                  }}
                  itemStyle={{
                    color: "#ffffff",
                  }}
                  cursor={{ fill: "rgba(255,255,255,0.08)" }}
                />
                <Bar
                  dataKey="revenue"
                  fill="url(#revenueGradient)"
                  radius={[8, 8, 0, 0]}
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Col>
      </Row>

      {/* TABLES */}
      <Row className="margin-none">
        <Col md={6}>
          <div className="top-sellers">
            <h5>Top Selling Items</h5>
            <span>most popular items by sale</span>

            <div className="tab">
              <table className="table-dashboard">
                <thead>
                  <tr>
                    <th>item name</th>
                    <th>type</th>
                    <th>price</th>
                    <th>units sold</th>
                  </tr>
                </thead>
                <tbody>
                  {selling?.map((item, i) => (
                    <tr key={i}>
                      <td>{item?.itemName}</td>
                      <td>{item?.itemType}</td>
                      <td>{item?.totalRevenue}</td>
                      <td>{item?.totalSold}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Col>

        <Col md={6}>
          <div className="users-activity">
            <h5>User Activity</h5>
            <span>daily active users</span>

            <div className="tab">
              <table className="table-dashboard">
                <thead>
                  <tr>
                    <th>item name</th>
                    <th>type</th>
                    <th>price</th>
                    <th>units sold</th>
                  </tr>
                </thead>
                <tbody>
                  {activity.map((item, i) => (
                    <tr key={i}>
                      <td>{item.name}</td>
                      <td>{item.type}</td>
                      <td>{item.price}</td>
                      <td>{item.sold}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
